import { orderByPlantGain, readPlants, PLANT_VARIETY_TARGET } from "../global/biond-global-helper";

export class BiondQuizInterface {
  constructor(biondMealGlobalInterface) {
    this.container = document.querySelector(".meal-selection-section");
    this.biondMealGlobalInterface = biondMealGlobalInterface;
    this.activeMealVariant = 0;
    this.isQuiz = true;
    this.selectedMenuList = document.getElementById("selected-meals-list");
    this.cartTimestamp = 0;
  }
  /*
  async getProducts(renderBox = true) {
    this.mealSelectionWrap.classList.add('is-loading');
    const params = new URLSearchParams();

  
    params.append('filter.p.m.custom.meal_types', `gid://shopify/Metaobject/${this.selectedMealType}`);
    params.append('filter.p.m.custom.side_dishs', `gid://shopify/Metaobject/${this.selectedSideDish}`);
    params.append("filter.p.status", "ACTIVE"); 
    params.append("filter.p.available", "true");
    params.append("filter.p.inventory_quantity", ">0");

    this.preferenceIds.forEach(id => {
      params.append('filter.p.m.custom.preferences', `gid://shopify/Metaobject/${id}`);
    });



    const url = `${this.getCollectionUrl()}?${params.toString()}`;
    console.log('🔗 Filter-URL:', url);

    try {
      console.log(url)
      const res = await fetch(url);
      const html = await res.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const grid = doc.querySelector('#product-grid');

      if (!grid) {
        console.warn('❌ Kein #product-grid gefunden.');
        return;
      }

      const content = grid.innerHTML;
      const mealGrid = document.querySelector('#meal-grid');
      mealGrid.innerHTML = "";
      mealGrid.insertAdjacentHTML('beforeend', content);
 
      this.mealSelectionWrap.classList.remove('is-loading');
      
    } catch (err) {
      console.error('❌ Fehler beim Laden der Collection-Seite:', err);
    }
  }
  getCollectionUrl() {
    const sideDishId = this.selectedSideDish;

    const collectionMap = {
      '323219718519': 'https://www.biond.de/collections/mahlzeiten-mit-beilage',
      '323219816823': 'https://www.biond.de/collections/mahlzeiten-ohne-beilage'
    };

    const url = collectionMap[sideDishId];

    if (!url) {
      console.warn(`❌ Unbekannter Side Dish (${sideDishId}) – Standard-Collection wird verwendet.`);
      return null;
    }

    return url;
  }
  async getMetaobjectNamesByIds(idGroups) {
    const entries = Object.entries(idGroups).flatMap(([groupKey, ids]) =>
      ids.map(id => ({ groupKey, id }))
    );

    if (entries.length === 0) {
      console.warn('⚠️ Keine IDs übergeben – Abbruch.');
      return {
        meal_types: [],
        preferences: [],
        side_dishs: []
      };
    }

    const query = `
      query GetMetaobjects {
        ${entries.map(({ groupKey, id }) => `
          ${groupKey}_${id}: node(id: "gid://shopify/Metaobject/${id}") {
            ... on Metaobject {
              fields {
                key
                value
              }
            }
          }
        `).join('')}
      }
    `;

    try {
      const response = await fetch('https://jw9wdd-tu.myshopify.com/api/2024-07/graphql', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': '22d24b254e1f56c5770f0671863f6a97',
        },
        body: JSON.stringify({ query })
      });

      const result = await response.json();

      const nameMap = {
        meal_types: [],
        preferences: [],
        side_dishs: []
      };

      entries.forEach(({ groupKey, id }) => {
        const key = `${groupKey}_${id}`;
        const obj = result?.data?.[key];
        const nameField = obj?.fields?.find(f => f.key === 'name');
        if (nameField) {
          nameMap[groupKey].push(nameField.value);
        } else {
          console.warn(`⚠️ Kein Name-Feld für ${key} gefunden.`);
        }
      });

      return nameMap;
    } catch (error) {
      console.error('❌ Fehler beim Abrufen der Metaobject-Namen:', error);
      return {
        meal_types: [],
        preferences: [],
        side_dishs: []
      };
    }
  }*/

  initProducts() {
    if (
      this.biondMealGlobalInterface.mealTypeIds.length > 0 &&
      this.biondMealGlobalInterface.sideDishIds.length > 0
    ) {
      const filterLabelSideDish = document.querySelector(
        `.custom-filter-quiz-content label[for="side_dishs_${this.biondMealGlobalInterface.sideDishIds[0]}"]`
      );
      const filterLabeMealType = document.querySelector(
        `.custom-filter-quiz-content label[for="meal_types_${this.biondMealGlobalInterface.mealTypeIds[0]}"]`
      );
      filterLabelSideDish.closest("li").classList.add("active");
      filterLabeMealType.closest("li").classList.add("active");
      filterLabelSideDish
        .closest(".custom-filter-quiz")
        .querySelector(".selected-filter-quiz").textContent =
        filterLabelSideDish.textContent;
      filterLabeMealType
        .closest(".custom-filter-quiz")
        .querySelector(".selected-filter-quiz").textContent =
        filterLabeMealType.textContent;

      this.biondMealGlobalInterface.getProducts();
      this.biondMealGlobalInterface.getExtras();
      this.selectedMenuList.innerHTML = "";

      if (
        !this.biondMealGlobalInterface.totalMealsCount ||
        this.biondMealGlobalInterface.totalMealsCount === 0
      ) {
        this.biondMealGlobalInterface.totalMealsCount = 5;
      }
      this.biondMealGlobalInterface.activeMealCount = 0;
      this.biondMealGlobalInterface.selectedMeals = [];

      this.biondMealGlobalInterface.renderBoxInfos();
      this.biondMealGlobalInterface.updateMealCounter();
      this.biondMealGlobalInterface.updateSaveButton();
      const radio = document.querySelector(
        `.quiz_products li.active[data-total="${this.biondMealGlobalInterface.totalMealsCount}"] input[type="radio"]`
      );
      if (radio) {
        radio.checked = true;
        radio.dispatchEvent(new Event("change", { bubbles: true }));
      }
      this.biondMealGlobalInterface.checkAndUpdateBoxSize();
      this.biondMealGlobalInterface.getSellingPlans();
      document.body.classList.remove("show-selection-wrap");
      //this.biondQuizInterface.renderSelectedBox();
    }
  }
  resetProductChoice() {
    this.selectedMenuList.innerHTML = "";
    if (
      !this.biondMealGlobalInterface.totalMealsCount ||
      this.biondMealGlobalInterface.totalMealsCount === 0
    ) {
      this.biondMealGlobalInterface.totalMealsCount = 5;
    }
    this.biondMealGlobalInterface.activeMealCount = 0;
    this.biondMealGlobalInterface.selectedMeals = [];
    this.biondMealGlobalInterface.selectedExtras = [];
    this.biondMealGlobalInterface.renderSelectedMeals();
    this.biondMealGlobalInterface.renderBoxInfos();
    this.biondMealGlobalInterface.updateMealCounter();
    this.biondMealGlobalInterface.updateSaveButton();
    this.biondMealGlobalInterface.checkAndUpdateBoxSize();
    this.biondMealGlobalInterface.getSellingPlans();
  }
  async checkPreSelection() {
    const requestParameter = this.parseQuizUrlParameters();
    //const selectedMeal = document.querySelector('.selection_meal_type input[type="radio"]:checked');
    //const selectedDish = document.querySelector('.selection_side_dish input[type="radio"]:checked');
    //const selectedPreferences = document.querySelectorAll('.filter-preferences input[type="checkbox"]:checked');
    //const selectedProducts = document.querySelector('.selection_products');
    console.log(requestParameter);
    const selectedMeal = requestParameter.request_meal_types;
    const selectedDish = requestParameter.request_side_dishes;
    const selectedPreferences = requestParameter.request_preferences;
    const selectedProducts = requestParameter.request_products;

    const autofill = requestParameter.request_autofill;
    const autofill_qty = requestParameter.request_autofill_qty;

    if (selectedMeal != 0 && selectedDish != 0) {
      this.biondMealGlobalInterface.mealTypeIds.push(String(selectedMeal));
      this.biondMealGlobalInterface.sideDishIds.push(String(selectedDish));

      const sideDishFilter = document.querySelector(
        `.section_product_filters label[for="side_dishs_${selectedDish}"]`
      );
      sideDishFilter
        .closest(".custom-filter-quiz")
        .querySelector(".selected-filter-quiz").textContent =
        sideDishFilter.textContent;
      sideDishFilter.closest("li").classList.add("active");

      const sideMealFilter = document.querySelector(
        `.section_product_filters label[for="meal_types_${selectedMeal}"]`
      );
      sideMealFilter
        .closest(".custom-filter-quiz")
        .querySelector(".selected-filter-quiz").textContent =
        sideMealFilter.textContent;
      sideMealFilter.closest("li").classList.add("active");

      if (selectedPreferences.length > 0) {
        const preferenceNames = [];

        selectedPreferences.forEach((preference) => {
          // IDs ins Interface pushen
          this.biondMealGlobalInterface.preferenceIds.push(preference);

          // Checkbox finden und aktiv setzen
          const checkbox = document.querySelector(
            `.filter-preferences input[value="${preference}"]`
          );
          if (checkbox) {
            checkbox.checked = true;
            const li = checkbox.closest("li");
            // Label-Text (Name) holen
            const labelText = li
              .querySelector(".filter-quiz-name")
              .textContent.trim();
            preferenceNames.push(labelText);
          }
        });

        // Kommasepariert in den Header schreiben
        const prefFilter = document.querySelector(
          ".filter-preferences .selected-filter-quiz"
        );
        if (prefFilter) {
          prefFilter.textContent = preferenceNames.join(", ");
        }
      }

      this.updateBoxes();
      const products = await this.biondMealGlobalInterface.getProducts();
      this.biondMealGlobalInterface.getExtras();

      //const preselected = selectedProducts.dataset.preselectedProducts;
      if (selectedProducts.length > 0 && autofill == undefined) {
        //console.log('Wert:', preselected);
        //const preselectedProductsDecoded = decodeURIComponent(preselected);
        // -> "14926378926455:3,14964961378679:1,14965034156407:1,..."

        // Schritt 2: Split nach Komma
        //const preselectedProductsSplit = selectedProducts.split(",");

        // Schritt 3: Loop durchgehen

        selectedProducts.forEach((preselectedProduct) => {
          //const [variantId, quantity] = preselectedProduct.split(":");
          this.biondMealGlobalInterface.addMeal(
            preselectedProduct.id,
            Number(preselectedProduct.qty),
            false
          );
        });
      } else if (autofill == "auto" || autofill_qty != 0) {
        let maxqty = 5;
        if (autofill_qty != 0) {
          maxqty = autofill_qty;
        }
        const radio = document.querySelector(
          `.quiz_products li.active[data-total="${autofill_qty}"] input[type="radio"]`
        );
        if (radio) {
          radio.checked = true;
          radio.dispatchEvent(new Event("change", { bubbles: true }));
        } else {
          const radiofirst = document.querySelector(
            `.quiz_products li.active[data-total="5"] input[type="radio"]`
          );
          radiofirst.checked = true;
          radiofirst.dispatchEvent(new Event("change", { bubbles: true }));
        }
        if (autofill == "auto") this.fillAuto(false);
      } else {
        const radio = document.querySelector(
          '.quiz_products li.active[data-total="5"] input[type="radio"]'
        );
        if (radio) {
          radio.checked = true;
          radio.dispatchEvent(new Event("change", { bubbles: true }));
        }
      }
    } else {
      document.querySelector("body").classList.add("show-selection-wrap");
    }
  }
  fillAuto(changeurl = true) {
    const products = Array.from(
      document.querySelectorAll(
        '.products-main .product-item[data-available="true"]'
      )
    );
    if (products.length === 0) return;

    if (this.biondMealGlobalInterface.isPlantVarietyActive()) {
      this.fillAutoWithPlantVariety(products, changeurl);
      return;
    }

    const maxCount = this.biondMealGlobalInterface.totalMealsCount;

    // Zufällig mischen
    const shuffled = products.sort(() => 0.5 - Math.random());

    if (products.length >= maxCount) {
      // Fall 1: genug Produkte vorhanden → wie bisher
      const selected = shuffled.slice(0, maxCount);
      selected.forEach((product) => {
        const variantId = product.dataset.variant;
        if (variantId) {
          this.biondMealGlobalInterface.addMeal(variantId, 1, changeurl);
        }
      });
    } else {
      // Fall 2: weniger Produkte als maxCount → Mengen hochsetzen
      const selected = shuffled; // alle Produkte nehmen
      const baseQty = Math.floor(maxCount / products.length);
      let remainder = maxCount % products.length;

      selected.forEach((product) => {
        const variantId = product.dataset.variant;
        if (variantId) {
          // jedem Produkt mindestens baseQty geben
          let qty = baseQty;
          // Rest gleichmäßig verteilen
          if (remainder > 0) {
            qty += 1;
            remainder--;
          }
          this.biondMealGlobalInterface.addMeal(variantId, qty, changeurl);
        }
      });
    }
  }

  /**
   * Füllt die Box so, dass mindestens PLANT_VARIETY_TARGET verschiedene
   * Pflanzen erreicht werden. Dieselbe Pflanze in mehreren Gerichten zählt
   * dabei nur einmal (Set-Deduplizierung in readPlants/orderByPlantGain).
   * Reicht die aktuelle Box-Stufe nicht aus, wird die nächstgrößere verfügbare
   * Stufe gewählt, so wie es der Kunde auch manuell tun könnte.
   */
  fillAutoWithPlantVariety(products, changeurl) {
    const alreadyCovered = this.biondMealGlobalInterface.getSelectedPlants();
    const ordered = orderByPlantGain(products, alreadyCovered);

    // Verfügbare Box-Stufen (z.B. 5, 7, 10 …), aufsteigend ab der aktuellen Stufe.
    const steps = Array.from(document.querySelectorAll('.quiz_products li.active'))
      .map((li) => parseInt(li.dataset.total, 10))
      .filter((n) => !Number.isNaN(n))
      .sort((a, b) => a - b);

    const currentTarget = this.biondMealGlobalInterface.totalMealsCount;
    const candidateSteps = steps.filter((s) => s >= currentTarget);
    if (candidateSteps.length === 0) candidateSteps.push(currentTarget);

    // Kleinste Stufe wählen, die das Ziel erreicht; sonst die größte verfügbare.
    let chosenStep = candidateSteps[candidateSteps.length - 1];
    for (const step of candidateSteps) {
      const covered = new Set(alreadyCovered);
      ordered.slice(0, step).forEach((product) => {
        readPlants(product).forEach((p) => covered.add(p));
      });
      if (covered.size >= PLANT_VARIETY_TARGET) {
        chosenStep = step;
        break;
      }
    }

    if (chosenStep !== currentTarget) {
      const radio = document.querySelector(
        `.quiz_products li.active[data-total="${chosenStep}"] input[type="radio"]`
      );
      if (radio) {
        radio.checked = true;
        radio.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }

    if (ordered.length >= chosenStep) {
      ordered.slice(0, chosenStep).forEach((product) => {
        const variantId = product.dataset.variant;
        if (variantId) {
          this.biondMealGlobalInterface.addMeal(variantId, 1, changeurl);
        }
      });
    } else {
      // Nicht genug unterschiedliche Gerichte verfügbar → Mengen hochsetzen wie bisher.
      const baseQty = Math.floor(chosenStep / ordered.length);
      let remainder = chosenStep % ordered.length;

      ordered.forEach((product) => {
        const variantId = product.dataset.variant;
        if (variantId) {
          let qty = baseQty;
          if (remainder > 0) {
            qty += 1;
            remainder--;
          }
          this.biondMealGlobalInterface.addMeal(variantId, qty, changeurl);
        }
      });
    }
  }
  parseQuizUrlParameters() {
    const params = {};

    // Zugriff auf den Query String der aktuellen URL
    const queryString = window.location.search;

    if (!queryString) {
      return {
        request_meal_types: 0,
        request_side_dishes: 0,
        request_products: [], // Immer ein leeres Array bei leerem Query
        request_preferences: [], // Immer ein leeres Array bei leerem Query
        request_autofill: "",
        request_autofill_qty: 0,
      };
    }

    // Erstellt ein URLSearchParams-Objekt, das das Parsen vereinfacht
    const urlParams = new URLSearchParams(queryString);

    // 1. meal_types (Erwartet einen numerischen System-ID-Wert)
    const mealTypes = urlParams.get("meal_types");
    if (mealTypes) {
      // Wandelt den String in eine Zahl um (oder 0, wenn ungültig)
      params.request_meal_types = parseInt(mealTypes, 10) || 0;
    } else {
      params.request_meal_types = 0;
    }

    // 2. side_dishs (Erwartet einen numerischen System-ID-Wert)
    const sideDishs = urlParams.get("side_dishs");
    if (sideDishs) {
      params.request_side_dishes = parseInt(sideDishs, 10) || 0;
    } else {
      params.request_side_dishes = 0;
    }
    const autofill = urlParams.get("fill");
    if (autofill) {
      params.request_autofill = autofill;
    }
    const autofillqty = urlParams.get("fill_qty");
    if (autofillqty) {
      params.request_autofill_qty = parseInt(autofillqty);
    }
    // 3. products (Wird von 'ID:QTY,ID:QTY' in ein Array von Objekten konvertiert)
    const products = urlParams.get("products");
    params.request_products = [];

    if (products) {
      // Beispiel-Input: '55708067758455:2,55150219395447:1'
      const productPairs = products.split(",");

      params.request_products = productPairs
        .map((pair) => {
          const parts = pair.split(":");
          if (parts.length === 2) {
            return {
              id: parts[0].trim(), // Produkt-ID als String
              qty: parseInt(parts[1].trim(), 10) || 1, // Menge als Zahl
            };
          }
          return null;
        })
        // Entfernt alle ungültigen oder fehlerhaft geparsten Paare
        .filter((item) => item !== null);
    }

    // 4. preferences (Bleibt ein Array von Strings)
    const preferences = urlParams.get("preferences");
    if (preferences) {
      // Trim und split nach Komma, leere Werte entfernen
      params.request_preferences = preferences
        .split(",")
        .map((p) => p.trim())
        .filter((p) => p.length > 0);
    } else {
      params.request_preferences = [];
    }

    return params;
  }

  updateBoxes() {
    // Nur wenn beide gewählt sind

    if (
      this.biondMealGlobalInterface.mealTypeIds.length <= 0 ||
      this.biondMealGlobalInterface.sideDishIds.length <= 0
    ) {
      // Falls du willst, kannst du hier alle Produkte neutral halten
      document
        .querySelectorAll('.quiz_products input[name="boxes"]')
        .forEach((prodInput) => {
          prodInput.closest("li").classList.remove("active");
        });
      return;
    }

    document
      .querySelectorAll('.quiz_products input[name="boxes"]')
      .forEach((prodInput) => {
        const mealTypes = prodInput.dataset.mealTypes?.split(",") || [];
        const sideDishes = prodInput.dataset.sideDishs?.split(",") || [];

        const mealMatch = mealTypes.includes(
          this.biondMealGlobalInterface.mealTypeIds[0]
        ); // nur ein Wert muss passen
        const sideMatch = sideDishes.includes(
          this.biondMealGlobalInterface.sideDishIds[0]
        ); // muss exakt passen

        if (mealMatch && sideMatch) {
          prodInput.closest("li").classList.add("active");
        } else {
          prodInput.closest("li").classList.remove("active");
        }
      });
  }
  cart_call(method = "update", data) {
    return fetch(
      (window.Shopify?.routes?.root || "/") + "cart/" + method + ".js",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }
    )
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }

  cart_call(method = "update", data) {
    return fetch(
      (window.Shopify?.routes?.root || "/") + "cart/" + method + ".js",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }
    )
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  async add_cart() {
    this.cartTimestamp = Date.now();
    const selectedSellingplan = document.querySelector(
      'input[name="selling_plan"]:checked'
    );
    let sellingplanId = this.biondMealGlobalInterface.selectedSellingPlanId;
    if (selectedSellingplan.value == "once") {
      sellingplanId = null;
    }
    const appstleBundleId = "CVIxGC1Ydn";
    const mealsForBundle = this.biondMealGlobalInterface.selectedMeals || [];
    const mealProperties = this.formatMealsForBundle(mealsForBundle);
    const itemsToAdd = [];
    
    // 🔧 FIX: Add ONLY ONE box (quantity: 1)
    // removeExistingBoxProductsFromCart() has already cleared any existing boxes
    // This ensures only one box can be in the cart at any time
    const boxItem = {
      id: this.biondMealGlobalInterface.activeBoxVariantId,
      quantity: 1, // Always add exactly one box
      properties: {
        "_appstle-bb-id": "CVIxGC1Ydn",
        "__appstle-bb-name": "Quiz Bundle",
        "__appstle-bb-variants": mealProperties.variantString,
        "__biond-box-id": this.cartTimestamp,
        // Human-readable product list
        products: mealProperties.productString,
      },
    };
    if (sellingplanId != null) {
      boxItem.selling_plan = sellingplanId;
    }
    // 🔧 NEW: Add extras as separate items (not part of bundle)
    if (
      this.biondMealGlobalInterface.selectedExtras &&
      this.biondMealGlobalInterface.selectedExtras.length > 0
    ) {
      this.biondMealGlobalInterface.selectedExtras.forEach((extra) => {
        itemsToAdd.push({
          id: extra.variantId,
          quantity: extra.quantity,
        });
      });
    }
    itemsToAdd.push(boxItem);

    
    try {
      await this.serverCheck();
    } catch (err) {
      // Abbrechen, nichts weiter tun

      document.querySelector(
        ".selling-plan-wrap .add-to-cart"
      ).disabled = false;
      return;
    }

    return this.cartAdd({
      items: itemsToAdd,
    })
      .then((response) => {
        this.savePreferences().then(() => {
          document.querySelector(
            ".selling-plan-wrap .add-to-cart"
          ).disabled = false;
          document.location.href = "/checkout";
        });

        return response;
      })
      .catch((error) => {
        console.error("❌ Failed to add selections to cart:", error);
        throw error;
      });
  }
  /**
   * Save preferences
   */
  async savePreferences() {
    const cartAttributes = await this.getCartAttributesViaAjax();

    let exitingCartAttributes = [];

    if (cartAttributes && cartAttributes.quiz_preferences) {
      exitingCartAttributes = JSON.parse(cartAttributes.quiz_preferences).boxes;
      if (!Array.isArray(exitingCartAttributes)) {
        exitingCartAttributes = [];
      }
    }
    const mealsForBundle = this.biondMealGlobalInterface.selectedMeals || [];

    const dataForCart = {
      "__biond-box-id": this.cartTimestamp,
      meal_types: this.biondMealGlobalInterface.mealTypeIds,
      preferences: this.biondMealGlobalInterface.preferenceIds,
      side_dishs: this.biondMealGlobalInterface.sideDishIds,
      box_size: this.biondMealGlobalInterface.activeBoxVariantId,
      selectedBox: {
        id: this.biondMealGlobalInterface.activeBoxVariantId,
        title: this.biondMealGlobalInterface.activeMealName,
        price: this.biondMealGlobalInterface.activeMealPriceValue,
        mealCount: this.biondMealGlobalInterface.totalMealsCount,
      },
      selling_plan: this.biondMealGlobalInterface.selectedSellingPlanId,
      selectedMeals: this.biondMealGlobalInterface.selectedMeals.map(
        (meal) => ({
          variantId: meal.variantId,
          quantity: meal.quantity,
          hasSpecial: meal.isSpecial || false,
          surchargeId: meal.surchargeId || null,
        })
      ),
    };
    exitingCartAttributes.push(dataForCart);

    const selectedExtras = this.biondMealGlobalInterface.selectedExtras.map(
      (meal) => ({
        variantId: meal.variantId,
        quantity: meal.quantity,
      })
    );

    const attributes = {};
    const dataToSave = {
      boxes: exitingCartAttributes,
      "__biond-challenge": this.biondMealGlobalInterface.isChallenge,
    };
    if (selectedExtras.length > 0) {
      dataToSave.selectedExtras = selectedExtras;
    }
    console.log(dataToSave);
    attributes["quiz_preferences"] = JSON.stringify(dataToSave);

    return this.cartUpdate({
      attributes: attributes,
    });
  }

  // HINWEIS: Dies ist die korrigierte Version
  getCartAttributesViaAjax() {
    return fetch("/cart.js") // 1. Explizites Zurückgeben des fetch-Promises
      .then((response) => {
        if (!response.ok) {
          // Fehlerbehandlung für schlechte HTTP-Status
          throw new Error(
            "Netzwerkantwort nicht OK. Status: " + response.status
          );
        }
        return response.json(); // 2. Antwort in JSON parsen
      })
      .then((data) => {
        // 3. Gibt nur die Attribute zurück, die das Promise auflösen
        return data.attributes;
      })
      .catch((error) => {
        console.error("Fehler beim Abrufen des Warenkorbs:", error);
        return null; // Gibt null im Fehlerfall zurück
      });
  }
  /**
   * Update cart
   *
   * @param data
   * @returns {Promise<*>}
   */
  cartUpdate(data) {
    return this.cart_call("update", data);
  }
  cartAdd(data) {
    return this.cart_call("add", data);
  }
  /**
   * Format meals for Appstle bundle properties
   * Creates the required strings for bundle integration
   *
   * @param {Array} selectedMeals - Array of selected meal objects
   * @returns {Object} Object with variantString and productString
   */
  formatMealsForBundle(selectedMeals) {
    if (!selectedMeals || selectedMeals.length === 0) {
      return {
        variantString: "",
        productString: "",
      };
    }

    // Format variant IDs and quantities: "variantID:quantity,variantID:quantity"
    const variantParts = selectedMeals.map(
      (meal) => `${meal.variantId}:${meal.quantity}`
    );
    
    const variantString = variantParts.join(",");

    // Format human-readable product list: "1x Product Name, 2x Another Product"
    const productParts = selectedMeals.map(
      (meal) => `${meal.quantity}x ${meal.title}`
    );
    const productString = productParts.join(", ");

    return {
      variantString,
      productString,
    };
  }
  async serverCheck() { 
    console.log("Server check started..."); 
    const selectedMeals = this.biondMealGlobalInterface.selectedMeals || [];

    // Meals nach variantId aggregieren (falls dieselbe Variante mehrfach vorkommt)
    const mealQtyByVariant = {};
    selectedMeals.forEach((meal) => {
      if (!meal.variantId) return;
      mealQtyByVariant[meal.variantId] =
        (mealQtyByVariant[meal.variantId] || 0) + meal.quantity;
    });
    const variantIds = Object.keys(mealQtyByVariant);

    // Aliase für die Bestandsabfrage bauen: v0, v1, v2, ...
    const variantQueryParts = variantIds
      .map(
        (id, i) => `
      v${i}: node(id: "gid://shopify/ProductVariant/${id}") {
        ... on ProductVariant {
          id
          title
          availableForSale
          quantityAvailable
        }
      }`
      )
      .join("");

    const query = `
    query {
      product(id: "gid://shopify/Product/${this.biondMealGlobalInterface.activeBoxProductId}") {
        title
        sideDishs: metafield(namespace: "custom", key: "side_dishs") {
          id
          type
          value
        }
        mealTypes: metafield(namespace: "custom", key: "meal_types") {
          id
          type
          value
        }
      }
      ${variantQueryParts}
    }
  `;

    try {
      const response = await fetch(
        "https://jw9wdd-tu.myshopify.com/api/2025-01/graphql",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Shopify-Storefront-Access-Token":
              "22d24b254e1f56c5770f0671863f6a97",
          },
          body: JSON.stringify({ query }),
        }
      );

      const result = await response.json();
      const productData = result?.data?.product;

      if (!productData) {
        showAlert("Box-Produkt konnte nicht geprüft werden.", "error");
        throw new Error("Box-Produkt nicht gefunden");
      }

      const maxValidMeals = parseInt(productData.title);

      // Metafelder können null sein, wenn nicht gesetzt -> defensiv parsen
      const mealTypeIds = JSON.parse(
        productData.mealTypes?.value || "[]"
      ).map((v) => v.replace("gid://shopify/Metaobject/", ""));
      const sideDishIds = JSON.parse(
        productData.sideDishs?.value || "[]"
      ).map((v) => v.replace("gid://shopify/Metaobject/", ""));

      console.log("VALID MealTypes:", mealTypeIds);
      console.log("VALID SideDishs:", sideDishIds);

      // Prüfen ob mindestens ein Meal die IDs enthält
      const hasValidMeal = selectedMeals.some((meal) => {
        const mealTypes = (meal.meal_types || "")
          .split(",")
          .map((str) => str.trim());
        const sideDishs = (meal.side_dishs || "")
          .split(",")
          .map((str) => str.trim());

        return (
          mealTypeIds.some((id) => mealTypes.includes(id)) ||
          sideDishIds.some((id) => sideDishs.includes(id))
        );
      });

      if (this.biondMealGlobalInterface.totalMealsCount > maxValidMeals) {
        showAlert(`Die Box Menge stimmt nicht.`, "error");
        throw new Error("Box Menge ungültig");
      }

      if (!hasValidMeal) {
        showAlert(`Kein gültiger MealType oder SideDish ausgewählt.`, "error");
        throw new Error("MealType/SideDish ungültig");
      }

      // 🔧 NEU: Bestandsprüfung für alle ausgewählten Meals
      const outOfStockTitles = [];

      variantIds.forEach((id, i) => {
        const variantData = result?.data?.[`v${i}`];
        console.log(variantIds);
        const neededQty = mealQtyByVariant[id];

        if (!variantData) {
          // Variante existiert nicht (mehr) / wurde gelöscht
          console.warn(`⚠️ Variante ${id} nicht gefunden im Storefront.`);
          outOfStockTitles.push(`Artikel nicht verfügbar (${id})`);
          return;
        }

        if (variantData.quantityAvailable === null) {
          // Inventory-Tracking / Scope nicht aktiv -> kann nicht geprüft werden,
          // wir verlassen uns dann nur auf availableForSale
          console.warn(
            `⚠️ quantityAvailable ist null für ${variantData.title} – prüfe nur availableForSale.`
          );
          if (!variantData.availableForSale) {
            outOfStockTitles.push(variantData.title);
          }
          return;
        }

        if (
          !variantData.availableForSale ||
          variantData.quantityAvailable < neededQty
        ) {
          outOfStockTitles.push(
            `${variantData.title} (verfügbar: ${variantData.quantityAvailable}, benötigt: ${neededQty})`
          );
        }
      });

      if (outOfStockTitles.length > 0) {
        showAlert(
          `Nicht genug Bestand für: ${outOfStockTitles.join(", ")}`,
          "error"
        );
        throw new Error("Bestand ungültig: " + outOfStockTitles.join(", "));
      }

      return true;
    } catch (error) {
      console.error("❌ Fehler beim Abrufen der Produktprüfung", error);
      throw error;
    }
  }
}
